import React from "react";

export default function Leaf({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
      <path
        d="M9 39C6 24 14 8 33 6c3 15-5 30-24 33z"
        fill="currentColor"
        opacity="0.9"
      />
      <path
        d="M10 38C16 26 22 17 32 8"
        stroke="rgba(0,0,0,0.15)"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
